export default __webpack_public_path__ + "static/media/icon_arrow_right.c958b10a.svg";